import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST_AC_BRAND: 'LIST_AC_BRAND',
};

export const listACBrand = () => ({
  type: ACTION.LIST_AC_BRAND,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_REF_AC_BRAND,
  })
    .then(response => response.data)
    .catch(err => Promise.reject(err.response.data)),
});


// WEBPACK FOOTER //
// ./src/redux/references/ac_actions.js